import mainService from "services/mainService";

/**
 * @description Cria uma nova unidade para uma empresa
 * @param {number} bigcompanyPk - PK da empresa
 * @param {Object} body - Corpo da requisição com os dados da unidade
 */
export function createUnit({ bigcompanyPk, body }) {
  return mainService.post(`v2/bigcompany/${bigcompanyPk}/units/`, body);
}
